export default __webpack_public_path__ + "static/media/intelligenceSelected.1c2fdae5.png";